export const SSRS_BASEURL = '/ReportServer/Pages/ReportViewer.aspx?'



// WEBPACK FOOTER //
// ./src/constants/reports.js